// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CANCEL = "Zru\u0161";
export const SAVE_DESCRIPTION = "Ulo\u017e popis";
